import {APP_INITIALIZER, NgModule} from '@angular/core';
// Imports third-party shared modules (angular, angular materials, covalent,..)

// App Services
import {UserinfoService} from "./components/index/service/userinfo.service";


@NgModule({
  imports: [
  ],
  declarations: [
  ],
  providers: [
    UserinfoService,
    {
      provide: APP_INITIALIZER,
      useFactory: (configService: UserinfoService) =>
        () => configService.loadUserInfo(),
      deps: [UserinfoService],
      multi: true
    },
  ],


})
export class InitModule {

}
